import styled from 'styled-components';
import { rem } from '../../utils';
const getSize = ({ size, theme }) => (size && rem(theme.Icon.Size[size])) || '150px';
export const SpinnerContainer = styled.div `
  position: relative;
  display: block;
  width: ${getSize};
  height: ${getSize};
`;
//# sourceMappingURL=LoadingSpinner.style.js.map